export const SET_POSTS_DATA = 'SET_POSTS_DATA';
export const ADD_POST = 'ADD_POST';
export const DELETE_POST = 'DELETE_POST';
export const ADD_TEXT_AREA = 'ADD_TEXT_AREA';
export const DELETE_TEXT_AREA = 'DELETE_TEXT_AREA';
export const CLEAN_POSTS_DATA = 'CLEAN_POSTS_DATA';
